import { Grid, Paper, ThemeProvider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { setLoading, unsetLoading, setCurrentAdminProject, createProject, updateProject, getProjectAdminData, resetResponseState, getAdminProject, setAdminProjectId } from "../../../store/appAction";
import _ from 'lodash';
import toastr from "toastr";
import { mainTheme } from '../../../theme';
import { FormHeaderPaper, FormTitleTypography } from "../../../components/CustomStyles/StyledComponents";
import { Formik } from "formik";
import ProjectForm from "../../../components/Forms/ProjectForm";
import { toastrCustomOptionsLonger } from "../../../constants/toastrOptions";
import { EDIT } from "../../../constants/modes";

const Project = () => {
    const dispatch = useDispatch();
    let { mode } = useParams();

    const projectDetails = useSelector(state => state.adminProject.projectDetails);
    const projectId = useSelector(state => state.adminProject.projectId);
    const { successMsg, errorMsg } = useSelector(state => state.common);

    const [intProjectDetails, setIntProjectDetails] = useState(undefined);
    const [formData, setFormData] = useState(undefined);

    const validationSchema = Yup.object({
        projectName: Yup.string("Enter project name").trim().required("Project name is required")
    });

    useEffect(() => {
        if (mode === EDIT && projectDetails?.id !== null) {
            dispatch(setLoading());
            dispatch(getAdminProject(projectId));
        }
        else {
            dispatch(setAdminProjectId(null));
            setFormData({
                id: '',
                projectName: '',
                description: '',
                administratorId: '',
                createdOn: '',
                lastModified: '',
                users: [],
            });
        }
        return () => {
            setIntProjectDetails(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (successMsg || errorMsg) {
            dispatch(unsetLoading());
            successMsg && toastr.success(successMsg);
            errorMsg && toastr.error(errorMsg, undefined, toastrCustomOptionsLonger);
            dispatch(resetResponseState());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [successMsg, errorMsg]);

    useEffect(() => {
        if (intProjectDetails && !_.isEmpty(intProjectDetails)) {
            setFormData({
                id: intProjectDetails?.id || '',
                projectName: intProjectDetails?.name || '',
                description: intProjectDetails?.description || '',
                administratorId: intProjectDetails?.projectOwnerUserId || '',
                createdOn: intProjectDetails?.creationTime || '',
                lastModified: intProjectDetails?.lastUpdated || '',
                users: intProjectDetails?.users || [],
            })
            dispatch(unsetLoading());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [intProjectDetails]);

    useEffect(() => {
        setIntProjectDetails(projectDetails);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectDetails])


    const handleSubmit = data => {
        dispatch(setLoading());
        if (mode === EDIT && projectId != null) {
            dispatch(updateProject(data));
        } else {
            dispatch(createProject(data));
        }
    };

    return (
        <>
            <ThemeProvider theme={mainTheme}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={8} lg={9}>
                        <FormHeaderPaper
                            sx={{
                                p: 2,
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <FormTitleTypography variant="h5" component="div">
                                {(mode === EDIT && projectDetails) ? 'Edit' : 'Create'} Project
                            </FormTitleTypography>
                            <Typography variant="body2" paragraph>
                                {' Create or modify your project details.'}
                            </Typography>
                        </FormHeaderPaper>
                    </Grid>
                    <Grid item md={12} >
                        <Paper
                            sx={{
                                p: 2,
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            {formData &&
                                <Formik
                                    enableReinitialize
                                    render={props => <ProjectForm {...props} mode={mode} />}
                                    initialValues={formData}
                                    validationSchema={validationSchema}
                                    onSubmit={handleSubmit}
                                />}
                        </Paper>
                    </Grid>
                </Grid>

            </ThemeProvider>

        </>
    );
}

export default Project